

































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { FormField } from '@/types';
import TextEditor from '@/components/Common/TextEditor.vue';

@Component({
  name: 'base-form',
  components: {
    TextEditor
  }
})
export default class BaseForm extends Vue {
  @Prop({ default: true })
  protected createForm!: boolean;
  @Prop()
  id!: number;

  protected modelId: number = this.id;
  protected isCreateForm: boolean = this.createForm;
  protected isBusy: boolean = false;
  protected fields: FormField[] | null = null;
  protected title: string | null = null;
  protected isCard: boolean = true;
  protected dataKey: string = '';
  protected redirectRoute: any = null;
  protected deleteRedirectRoute: any = null;
  protected successMsg: string = 'Form saved.';
  protected deleteSuccessMsg: string = 'Successfully deleted.';
  protected saveBtnText: string = 'Save';

  get deleteBtnText() {
    return '';
  }

  // on server side data load internal event handler
  onSSD(ssd: any): any {
    this.$emit('on-ssd', ssd);
    return ssd;
  }

  async submitForm(data: any): Promise<any> {}

  async loadFormData(id: number): Promise<any> {}

  getFormData(): any {
    const data: any = {};
    this.fields!.forEach((field: FormField) => {
      if (field.type === 'options') {
        field.options!.forEach((op: any) => {
          data[op.key] = op.data;
        });
      } else {
        data[field.key] = field.data;
      }
    });
    return data;
  }

  setFormData(data: any): void {
    this.fields!.forEach((field: FormField) => {
      if (field.type === 'options') {
        field.options!.forEach((op: any) => {
          op.data = data[op.key];
        });
      } else {
        field.data = data[field.key];
      }
    });
  }

  async onSubmit(e: Event): Promise<any> {
    e.preventDefault();
    const data = this.getFormData();
    this.isBusy = true;
    const newData = await this.submitForm(data);
    this.isBusy = false;
    this.onSubmitted(newData);
  }

  async onDelete(e: Event) {
    e.preventDefault();
    try {
      await this.$confirm('Are you sure?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      });
      this.isBusy = true;
      const newData = await this.deleteForm();
      this.isBusy = false;
      this.onDeleted();
    } catch (e) {
      // blank
    }
  }

  async deleteForm(): Promise<any> {}

  onDeleted() {
    this.$notify.success(this.deleteSuccessMsg);
    if (this.deleteRedirectRoute) {
      this.$router.push(this.deleteRedirectRoute);
    }
  }

  onSubmitted(newData: any) {
    if (newData) {
      this.$notify.success(this.successMsg);
      if (this.redirectRoute) {
        this.$router.push(this.redirectRoute);
      }
    }
  }

  afterFormDataSet(formData: any) {}

  async loadForm() {
    this.isBusy = true;
    const formData = await this.loadFormData(this.modelId as number);
    this.setFormData(formData);
    this.afterFormDataSet(formData);
    this.isBusy = false;
  }

  async mounted() {
    this.redirectRoute = this.$route.meta.parentRoute
      ? { name: this.$route.meta.parentRoute }
      : null;

    if (!this.isCreateForm) {
      await this.loadForm();
    }
  }
}
